
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.871 10.743h7.334a4 4 0 002.22-.671A4 4 0 0016.9 8.28L18.179 5.2c.106-.253.278-.253.382 0l.81 1.978c2.4 1.516 3 1.527 3 3.246a1.312 1.312 0 01-1.312 1.313h-1.188l-1.5 3-1.31 5.242a1 1 0 01-.971.758.756.756 0 01-.534-.223.755.755 0 01-.219-.535c.024-3.372-.226-4.242-4.466-4.242-5.662 0-6.187 1.909-7.742 4.512-.544.911-1.771.421-1.446-.383.646-1.6 2.032-5.057 2.922-7.539a4.1 4.1 0 01-2.234-4.09c0-4.828 5.2-6.778 5.831-3.018.159.966-1.2 1.419-1.468.606C5.9 3.344 2.46 8.7 5.871 10.743z","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M9.371 15.864l.4 4.252a.574.574 0 01-1.094.29L6.8 16.293m10.753 1.722l1.521 2.285c.57.855 1.7.359 1.374-.384-.206-.472-.5-1.215-2.077-5.171m.766-5.752a.25.25 0 01.25.25m-.5 0a.25.25 0 01.25-.25m0 .5a.25.25 0 01-.25-.25m.5 0a.25.25 0 01-.25.25","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    